import { window } from '../globals';

/**
 * Determine a full URL for an org, including the org's subdomain.
 *
 * @param {string} subdomain - Organization's subdomain
 */
export const formatSubdomainToFullURL = (subdomain: string): string => {
  const host = subdomain ? `${subdomain}.${window.customerDomain}` : window.customerDomain;

  return `${window.location.protocol}//${host}`;
};

/**
 * Retrieves the base URL (protocol, hostname, and port if available) of the current page.
 *
 * @returns {string} The base URL of the current page.
 */
export function getBaseURL() {
  const { protocol, hostname, port } = window.location;

  return port ? `${protocol}//${hostname}:${port}` : `${protocol}//${hostname}`;
}
